<template>
  <v-app class="grey lighten-4">
    <NavBar v-if="$router.currentRoute.name !== 'home'" />

    <v-content class="backg">
      <router-view></router-view>
    </v-content>

    <v-dialog-bottom-transition>
      <v-snackbar
        v-model="refresh"
        v-if="message != '' && message != undefined && active"
        bottom
        right
        :timeout="3000"
      >{{ message }}</v-snackbar>
    </v-dialog-bottom-transition>

    <br />

    <v-footer app v-if="$router.currentRoute.name !== 'home'">
      <span>&copy; 2019 - Powered By IoT Application And Hardware AB</span>
    </v-footer>
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar";
import { mapActions, mapState } from "vuex";

export default {
  name: "App",
  components: {
    NavBar
  },
  data() {
    return {
      refresh: false,
      darkTheme: this.$vuetify.theme.dark,
      showAlert: false,
      landing: false
    };
  },

  created() {
    this.clear();
    this.showAlert = this.active;
  },

  updated() {
    if (this.$router.currentRoute.name == "home") {
      this.landing = true;
    }
  },

  computed: {
    ...mapState("alert", ["active", "message"])
  },

  methods: {
    ...mapActions("alert", ["clear"])
  },

  watch: {
    showAlert(val) {
      if (val === true) {
        this.refresh = true;
      }
    },

    refresh(value) {
      if (value === false) {
        this.clear();
      }
    }
  }
};
</script>

<style>
.backg {
  background-image: url("/landing-bg.jpg");
  background-size: cover;
}
</style>
